import React from "react";
import { Link } from "react-router-dom";

export default class ModelTabs extends React.Component {
  render() {
    let nav = {
      default: "Общее",
      prop: "Свойства",
      files: "Файлы",
    };
    const { modelId, categoryId, mode } = this.props;
    return (
      <ul className="nav nav-tabs mb-4">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/model/${categoryId}/${modelId}/${id}/`}
              className={` ${
                mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
